import { removeMdnFormatting } from "@expert/common-ui";
import { useMemo } from "react";
import { useTypedMostRecentTask } from "@/sdk";
import { isBlocklisted } from "../utils";

interface UseTaskMdnProps {
    blocklistedNumbers?: string[];
    blocklistedPrefixes?: string[];
}

export const useTaskMdn = ({ blocklistedNumbers, blocklistedPrefixes }: UseTaskMdnProps) => {
    const { isVoice, isChat, voiceTask, chatTask } = useTypedMostRecentTask();

    const taskMdn = useMemo(() => {
        let mdn = "";

        if (isVoice && voiceTask) {
            // TODO: when task is rehydrated the abstraction fails, we need fallback to empty string until we fix the rehydration
            mdn = voiceTask.mdn ?? "";
        } else if (isChat && chatTask) {
            // The chat task's mdn comes in formatted with the mask used in the chat UI, so we need to remove that formatting
            const unformattedMdn = removeMdnFormatting(chatTask.mdn.value ?? "");

            mdn = unformattedMdn.length === 10 ? `+1${unformattedMdn}` : unformattedMdn;
        }

        return isBlocklisted(mdn, blocklistedNumbers, blocklistedPrefixes) ? "" : mdn;
    }, [isVoice, isChat, voiceTask, chatTask, blocklistedNumbers, blocklistedPrefixes]);

    return taskMdn;
};
